const defaultDeductions = [
    "Overpayment",
    "Healthcare",
    "Cycle to Work",
    "Repayments"
];

export default defaultDeductions;